import type { MRT_ColumnDef } from "mantine-react-table-open";
import { DateInput } from "../../../../../../mantine/dates/DateInput/DateInput";
import { backendDateOrDateTimeToLuxonDateTimeOrNull } from "../../../../../../utils/dates/backendDateOrDateTimeToLuxonDateTimeOrNull";
import { luxonDateTimeToBackendDateOrDateTime } from "../../../../../../utils/dates/luxonDateTimeToBackendDateOrDateTime";
import type { FictionalEnergyValueResponse } from "../../FictionalEnergyValueManager/FictionalEnergyValueManager";
import { updateRowData } from "./updateRowData";

function getFirstDateColumn(
  creationError: string | null,
  editingError: string | null
): MRT_ColumnDef<FictionalEnergyValueResponse> {
  return {
    accessorKey: "firstDate",
    header: "Startdatum",
    size: 120,
    Edit: ({ table, row, cell }) => {
      const savedValue =
        cell.getValue() as FictionalEnergyValueResponse["firstDate"];
      const firstDate =
        backendDateOrDateTimeToLuxonDateTimeOrNull(savedValue) ?? undefined;
      return (
        <DateInput
          defaultValue={firstDate}
          error={
            table.getState().creatingRow?.id === row.id
              ? creationError
              : editingError
          }
          placeholder="Startdatum"
          onChange={(value) =>
            updateRowData({
              table,
              row,
              columnIds: ["firstDate"],
              newValues: [
                value ? luxonDateTimeToBackendDateOrDateTime(value) : null
              ]
            })
          }
        />
      );
    }
  };
}

export { getFirstDateColumn };
